// @flow

import styled from 'styled-components';
import type { Theme } from '../../types';

export const Wrapper = styled<any, Theme>('div')`
  display: flex;
  flex-direction: column;
`;

export const SubTitle = styled<any, Theme>('h2')`
  color: ${props => props.theme.orderForm.subtitleColor};
  font-size: 1.4rem;
  font-weight: bold;
  margin: 1rem 0 2rem;
`;

export const Form = styled<any, Theme>('form')`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const Label = styled<any, Theme>('label')`
  display: block;
  float: left;
  margin-right: 3rem;
`;

export const AgreeBox = styled<any, Theme>('div')`
  border-top: 1px solid ${props => props.theme.orderForm.borderColor};
  border-bottom: 1px solid ${props => props.theme.orderForm.borderColor};
  margin: 1.5rem 0;
  padding: 1.5rem 0 1rem;
`;

export const AgreeOption = styled<any, Theme>('div')`
  display: flex;
  padding: 0.5rem 0 1rem;
`;

export const ComfortText = styled<any, Theme>('p')`
  margin: 2rem 0;
`;
